import { siteInfo } from '@/mocks/manga';

export default function StatsSection() {
  const stats = [
    { value: siteInfo.stats.totalManga, label: '漫画资源' },
    { value: siteInfo.stats.dailyVisitors, label: '日访问量' },
    { value: siteInfo.stats.totalChapters, label: '更新章节' },
    { value: siteInfo.stats.satisfaction, label: '用户好评' },
  ];

  return (
    <section className="py-10 md:py-14">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {stats.map((stat) => (
            <div
              key={stat.label}
              className="text-center p-5 rounded-lg border border-background-200/70 bg-background-50"
            >
              <p className="text-2xl md:text-3xl font-bold text-accent-600 font-heading">{stat.value}</p>
              <p className="text-sm text-foreground-500 mt-1">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}